import React from "react";
import { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from 'swiper/react';
import { motion } from "framer-motion";
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { Pagination, Autoplay, Navigation, Keyboard } from 'swiper/modules';
import { Parallax, useParallax } from 'react-scroll-parallax';
import { Link } from "react-router-dom";

const About = () => {

  const [active, setActive] = useState("marketing");

  const awards = [
    {
      id: 1,
      title: "Digital Transformation Excellence (2025)",
      organization: "CXO Junction - Delhi"
    },
    {
      id: 2,
      title: "Cybersecurity Leadership Award (2025)",
      organization: "CXO Junction - Bangalore"
    },
    {
      id: 3,
      title: "Cybersecurity Leadership (2024)",
      organization: "CXO Junction - Mumbai"
    },
    {
      id: 4,
      title: "Innovation in Cyber Defense (2025)",
      organization: "CXO Junction - Mumbai"
    },
    {
      id: 5,
      title: "Best Security Solution Partner (2025)",
      organization: "24th VARINDIA Awards"
    }
  ];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      {/* Breadcrumb Hero Section */}

      <section className="execution-banner">
        <div className="execution-banner__shade"></div>

        <div className="execution-banner__content">
          <h1>
            Trusted IT Execution. Real <br />
            Business Outcomes.
          </h1>

          <p>
            From cloud migration to cybersecurity and managed IT services,
            <br />
            Solaris Performance Consistency helps organisations modernise, secure, and scale without
            <br />
            disruption and complexity
          </p>
        </div>
      </section>

      <section className="about-section py-5">
        <div className="container">
          <div className="row align-items-center g-5">
            {/* Left Content */}
            <div className="col-lg-6">
              <div className="about-content-wrapper p-4 p-md-5 bg-white rounded-4 shadow-sm h-100 position-relative z-1" style={{ borderLeft: '5px solid #0056b3' }}>
                <h2 className="intro-about-heading fw-bold mb-4" style={{ fontSize: '2.5rem', color: '#1a1a1a', letterSpacing: '-0.5px' }}>
                  About Solaris
                </h2>
                <p className="about-description text-muted fs-5 lh-lg mb-0" style={{ fontWeight: 400 }}>
                  Solaris Performance Consistency is a trusted IT solutions and technology services company dedicated to helping businesses improve operational efficiency, strengthen security, and accelerate digital transformation. With years of industry experience, we deliver reliable solutions across IT infrastructure, cloud services, cybersecurity, networking, data center management, software solutions, consulting, and managed support services.                </p>
              </div>
            </div>

            {/* Right Content - Image */}
            <div className="col-lg-6">
              <div className="about-image-container position-relative h-100 rounded-4 overflow-hidden shadow-lg">
                <div className="about-shape-1"></div>
                <div className="about-shape-2"></div>
                <div className="about-shape-3"></div>
                <div className="about-image-wrapper h-100">
                  <img
                    src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
                    alt="Corporate Team Working"
                    className="about-main-image w-100 h-100 object-fit-cover"
                    style={{ minHeight: '400px', transform: 'scale(1.05)', transition: 'transform 0.5s ease' }}
                  />
                  {/* Subtle overlay for better text contrast if needed anywhere else, or just raw stylings */}
                  <div className="position-absolute top-0 start-0 w-100 h-100 bg-dark opacity-10"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="purpose-modern-section" style={{ position: 'relative', overflow: 'hidden' }}>
        {/* Glow Effects */}
        <div className="purpose-glow-1"></div>
        <div className="purpose-glow-2"></div>

        <div className="purpose-modern-container" style={{ position: 'relative', zIndex: 2 }}>
          <div className="purpose-modern-left">
            <span className="purpose-modern-badge">VISION & MISSION</span>

            <h2>
              Purpose-Built for <br />
              <span style={{
                background: 'linear-gradient(135deg, #38bdf8 0%, #0ea5e9 50%, #2563eb 100%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                display: 'inline-block'
              }}>
                Enterprise <br />
                Modernisation
              </span>
            </h2>

            <p>
              A clear purpose: make enterprise technology simpler,
              stronger, and future-ready.
            </p>
          </div>

          <div className="purpose-modern-right">
            <div className="purpose-info-card">
              <div className="purpose-icon-box purpose-cube-icon">
                <span></span>
              </div>

              <h3>Brand Vision</h3>

              <p>
                To become a leading and trusted technology partner by delivering innovative, secure, and scalable IT solutions that empower organizations to achieve sustainable growth, operational excellence, and digital transformation.
              </p>
            </div>

            <div className="purpose-info-card purpose-mission-card">
              <div className="purpose-icon-box purpose-circle-icon">
                <span></span>
              </div>
              <h3>Brand Mission</h3>
              <p>
                To deliver innovative, secure, and reliable technology solutions that help businesses improve efficiency, accelerate growth, and achieve digital transformation. We are committed to providing exceptional service, building long-term partnerships, and creating lasting value for our customers through technology and innovation.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="cyber-who-we-are-section" style={{
        background: 'linear-gradient(180deg, #ffffff 0%, #f8fafc 100%)',
        position: 'relative',
        padding: '100px 0',
        overflow: 'hidden'
      }}>
        {/* Animated Background Elements */}
        <div style={{
          position: 'absolute',
          top: '10%',
          right: '10%',
          width: '300px',
          height: '300px',
          background: 'radial-gradient(circle, rgba(37, 99, 235, 0.05), transparent 70%)',
          borderRadius: '50%',
          filter: 'blur(40px)',
          animation: 'float 6s ease-in-out infinite'
        }}></div>
        <div style={{
          position: 'absolute',
          bottom: '10%',
          left: '10%',
          width: '250px',
          height: '250px',
          background: 'radial-gradient(circle, rgba(14, 165, 233, 0.05), transparent 70%)',
          borderRadius: '50%',
          filter: 'blur(40px)',
          animation: 'float 8s ease-in-out infinite reverse'
        }}></div>

        <div className="container" style={{ position: 'relative', zIndex: 2 }}>
          {/* Title Section */}
          <div className="text-center mb-5" style={{
            animation: 'fadeInDown 1s ease-out'
          }}>
            <p style={{
              color: '#2563eb',
              fontSize: '0.9rem',
              fontWeight: '600',
              letterSpacing: '3px',
              textTransform: 'uppercase',
              marginBottom: '15px'
            }}>YOUR DIGITAL TRUST PARTNER</p>
            <h2 style={{
              color: '#0f172a',
              fontSize: '3.5rem',
              fontWeight: '800',
              marginBottom: '20px',
              letterSpacing: '-1px'
            }}>
              Who We Are
            </h2>
            <div style={{
              width: '80px',
              height: '4px',
              background: 'linear-gradient(90deg, #2563eb, #0ea5e9)',
              margin: '0 auto',
              borderRadius: '2px'
            }}></div>
          </div>

          <div className="row align-items-center g-5">
            {/* Left Content */}
            <div className="col-lg-6">
              <div style={{
                backgroundColor: '#ffffff',
                padding: '40px',
                borderRadius: '24px',
                border: '1px solid #e2e8f0',
                boxShadow: '0 10px 30px -10px rgba(0, 0, 0, 0.05)',
                transition: 'transform 0.3s ease'
              }}>
                <p style={{
                  color: '#334155',
                  fontSize: '1.2rem',
                  lineHeight: '1.8',
                  marginBottom: '25px',
                  textAlign: 'left'
                }}>
                  <span style={{
                    color: '#2563eb',
                    fontWeight: '800',
                    fontSize: '1.35rem',
                  }}>Solaris Performance Consistency</span> is more than just a cyber security company in India – we are your digital defense partner.
                </p>
                <p style={{
                  color: '#475569',
                  fontSize: '1.05rem',
                  lineHeight: '1.8',
                  textAlign: 'left'
                }}>
                  Our team consists of certified security experts, ethical hackers, and technology strategists with years of hands-on experience in combating advanced cyber threats. We combine human intelligence with cutting-edge tools to provide robust, real-time protection for your business.
                </p>

                {/* Stats Section */}
                <div className="row mt-5 g-3">
                  <div className="col-4">
                    <div style={{ textAlign: 'center', padding: '15px 10px', background: '#f8fafc', borderRadius: '16px', border: '1px solid #f1f5f9' }}>
                      <h3 style={{
                        color: '#2563eb',
                        fontSize: '2.3rem',
                        fontWeight: '800',
                        marginBottom: '5px',
                      }}>15+</h3>
                      <p style={{ color: '#475569', fontSize: '0.8rem', fontWeight: '600', margin: 0 }}>Years Experience</p>
                    </div>
                  </div>
                  <div className="col-4">
                    <div style={{ textAlign: 'center', padding: '15px 10px', background: '#f8fafc', borderRadius: '16px', border: '1px solid #f1f5f9' }}>
                      <h3 style={{
                        color: '#0ea5e9',
                        fontSize: '2.3rem',
                        fontWeight: '800',
                        marginBottom: '5px',
                      }}>500+</h3>
                      <p style={{ color: '#475569', fontSize: '0.8rem', fontWeight: '600', margin: 0 }}>Clients Protected</p>
                    </div>
                  </div>
                  <div className="col-4">
                    <div style={{ textAlign: 'center', padding: '15px 10px', background: '#f8fafc', borderRadius: '16px', border: '1px solid #f1f5f9' }}>
                      <h3 style={{
                        color: '#2563eb',
                        fontSize: '2.3rem',
                        fontWeight: '800',
                        marginBottom: '5px',
                      }}>99.9%</h3>
                      <p style={{ color: '#475569', fontSize: '0.8rem', fontWeight: '600', margin: 0 }}>Success Rate</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Content - Sectors */}
            <div className="col-lg-6">
              <div style={{
                backgroundColor: '#ffffff',
                padding: '40px',
                borderRadius: '24px',
                border: '1px solid #e2e8f0',
                boxShadow: '0 10px 30px -10px rgba(0, 0, 0, 0.05)'
              }}>
                <h4 style={{
                  color: '#0f172a',
                  fontSize: '1.8rem',
                  fontWeight: '700',
                  marginBottom: '30px',
                  textAlign: 'left'
                }}>
                  We serve clients across sectors:
                </h4>
                <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                  {[
                    { icon: '🏦', text: 'Banking & Finance' },
                    { icon: '🏥', text: 'Healthcare & Pharmaceuticals' },
                    { icon: '🏭', text: 'Manufacturing & Supply Chain' },
                    { icon: '🛒', text: 'E-commerce & Retail' },
                    { icon: '🏛️', text: 'Government & Public Sector' }
                  ].map((item, index) => (
                    <li key={index} style={{
                      padding: '14px 20px',
                      marginBottom: '12px',
                      background: '#f8fafc',
                      borderRadius: '16px',
                      fontSize: '1.1rem',
                      display: 'flex',
                      alignItems: 'center',
                      border: '1px solid #e2e8f0',
                      transition: 'all 0.3s ease',
                      cursor: 'pointer',
                    }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = 'translateX(8px)';
                        e.currentTarget.style.background = 'linear-gradient(135deg, rgba(37, 99, 235, 0.06), rgba(14, 165, 233, 0.03))';
                        e.currentTarget.style.borderColor = '#93c5fd';
                        e.currentTarget.firstChild.style.transform = 'scale(1.1)';
                        e.currentTarget.firstChild.style.backgroundColor = '#dbeafe';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = 'translateX(0)';
                        e.currentTarget.style.background = '#f8fafc';
                        e.currentTarget.style.borderColor = '#e2e8f0';
                        e.currentTarget.firstChild.style.transform = 'scale(1)';
                        e.currentTarget.firstChild.style.backgroundColor = '#eff6ff';
                      }}>
                      <span style={{
                        fontSize: '1.4rem',
                        marginRight: '16px',
                        width: '40px',
                        height: '40px',
                        borderRadius: '50%',
                        backgroundColor: '#eff6ff',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        transition: 'all 0.3s ease'
                      }}>{item.icon}</span>
                      <span style={{
                        color: '#1e293b',
                        fontWeight: '600',
                      }}>{item.text}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="awards-section py-5">
        <div className="container text-center">
          <span className="awards-badge">Awards & Certificates</span>
          <h2 className="awards-title">
            Standards that strengthen <span>governance</span>, <br />
            reliability, and enterprise confidence.
          </h2>

          <Swiper
            modules={[Autoplay, Navigation, Pagination]}
            spaceBetween={24}
            slidesPerView={1}
            navigation={{
              prevEl: '.award-prev',
              nextEl: '.award-next',
            }}
            autoplay={{
              delay: 3500,
              disableOnInteraction: false,
            }}
            breakpoints={{
              576: {
                slidesPerView: 2,
                spaceBetween: 20
              },
              768: {
                slidesPerView: 3,
                spaceBetween: 24
              },
              1200: {
                slidesPerView: 4,
                spaceBetween: 24
              }
            }}
            className="awards-swiper pb-4"
          >
            {awards.map((award) => (
              <SwiperSlide key={award.id}>
                <div className="award-card">
                  <div className="award-icon-wrapper">
                    {/* Laurel wreath SVG */}
                    <svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" className="laurel-wreath-svg" style={{ position: 'absolute', width: '100%', height: '100%', left: 0, top: 0 }}>
                      <path d="M30 75C22 68 18 58 18 47C18 30 30 18 45 18M70 75C78 68 82 58 82 47C82 30 70 18 55 18" stroke="#cbd5e1" strokeWidth="2" strokeLinecap="round" strokeDasharray="4 4" />
                      {/* Laurel leaves left */}
                      <path d="M22 62C20 60 16 62 16 65C16 68 20 68 22 66" fill="#cbd5e1" />
                      <path d="M19 50C17 48 13 50 13 53C13 56 17 56 19 54" fill="#cbd5e1" />
                      <path d="M20 38C18 36 14 38 14 41C14 44 18 44 20 42" fill="#cbd5e1" />
                      <path d="M25 27C23 25 19 27 19 30C19 33 23 33 25 31" fill="#cbd5e1" />
                      <path d="M33 19C31 17 27 19 27 22C27 25 31 25 33 23" fill="#cbd5e1" />
                      {/* Laurel leaves right */}
                      <path d="M78 62C80 60 84 62 84 65C84 68 80 68 78 66" fill="#cbd5e1" />
                      <path d="M81 50C83 48 87 50 87 53C87 56 83 56 81 54" fill="#cbd5e1" />
                      <path d="M80 38C82 36 86 38 86 41C86 44 82 44 80 42" fill="#cbd5e1" />
                      <path d="M75 27C77 25 81 27 81 30C81 33 77 33 75 31" fill="#cbd5e1" />
                      <path d="M67 19C69 17 73 19 73 22C73 25 69 25 67 23" fill="#cbd5e1" />
                    </svg>
                    {/* Trophy SVG in the center */}
                    <svg width="44" height="44" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="trophy-svg" style={{ position: 'relative', zIndex: 2 }}>
                      <path d="M19 5h-2V3H7v2H5C3.9 5 3 5.9 3 7v1c0 2.55 1.92 4.66 4.39 4.94C8.3 14.54 10 15.63 10 17v2H8v2h8v-2h-2v-2c0-1.37 1.7-2.46 2.61-4.06C19.08 12.66 21 10.55 21 8V7c0-1.1-.9-2-2-2zM5 8V7h2v3.82C5.84 10.4 5 9.3 5 8zm14 0c0 1.3-.84 2.4-2 2.82V7h2v1z" fill="#EAB308" />
                    </svg>
                  </div>
                  <h4 className="award-name">{award.title}</h4>
                  <p className="award-organization">{award.organization}</p>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>

          {/* Custom navigation below Swiper */}
          <div className="awards-nav-wrapper">
            <button className="award-nav-btn award-prev">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M15 19L8 12L15 5" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </button>
            <button className="award-nav-btn award-next">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9 5L16 12L9 19" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </button>
          </div>
        </div>
      </section>

      <section className="transform-it-section pb-5 pt-3">
        <div className="container">
          <motion.div
            className="transform-card position-relative rounded-4 overflow-hidden"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            style={{ minHeight: '400px', borderRadius: '20px' }}
          >
            {/* Background Image */}
            <div
              className="position-absolute top-0 start-0 w-100 h-100"
              style={{
                backgroundImage: `url('https://images.unsplash.com/photo-1573164713988-8665fc963095?q=80&w=1200&auto=format&fit=crop')`,
                backgroundSize: 'cover',
                backgroundPosition: 'center 30%',
              }}
            ></div>

            {/* Gradient Overlay for text readability */}
            <div
              className="position-absolute top-0 start-0 w-100 h-100"
              style={{
                background: 'linear-gradient(to right, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.3) 50%, rgba(0,0,0,0) 100%)'
              }}
            ></div>

            {/* Content */}
            <div className="position-relative h-100 d-flex align-items-center p-5">
              <div className="content-wrapper ms-md-4" style={{ maxWidth: '500px' }}>
                <h2 className="fw-bold text-white mb-4" style={{ fontSize: 'clamp(2.5rem, 5vw, 4rem)', lineHeight: '1.2' }}>
                  Transform IT.<br />
                  Empower Growth.
                </h2>

                <Link to="/contact" className="d-inline-flex bg-white rounded-pill p-1 ps-4 pe-2 align-items-center text-decoration-none shadow" style={{ transition: 'transform 0.3s ease' }} onMouseOver={(e) => e.currentTarget.style.transform = 'scale(1.05)'} onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1)'}>
                  <span className="text-dark fw-bold me-3" style={{ fontSize: '1rem' }}>Get In Touch</span>
                  <div className="rounded-circle d-flex align-items-center justify-content-center" style={{ backgroundColor: '#3b82f6', width: '40px', height: '40px' }}>
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M7 17L17 7M17 7H7M17 7V17" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </div>
                </Link>
              </div>
            </div>
          </motion.div>
        </div>
      </section>
    </>
  );
};

export default About;
